import React, { useState, useEffect } from 'react';
import HeaderTitle from '../../../utils/HeaderTitle/HeaderTitle';
import NormalTabs from '../../../utils/ScrollableTab/NormalTabs';
import { Breadcrumb, BreadcrumbLink } from '../../../utils/Breadcrumbs/Breadcrumbs';
import { useTranslation } from 'react-i18next';
import { Status } from './maintenanceAidTab/status';
import Isir from './maintenanceAidTab/isir'
import IsirHistorical from './maintenanceAidTab/isirHistorical'
import Awards from './maintenanceAidTab/awards'
import Documents from './maintenanceAidTab/documents';
import { financialAid_maintenance } from "../../../services/navigation_folder/financialAid";
import More from './maintenanceAidTab/more';
import { useDispatch } from 'react-redux';
import { getSelectedProfiles } from '../../../redux/common/search-data/action';
import { useHistory } from 'react-router';
import CustomLoader from '../../../components/Loader/Loader';
import { ButtonWrapperFilter } from '../../../styles/common-styles';
import AlertsModal from '../../../components/Modal/AlertsModal';
import { Button } from '@material-ui/core';
import { getApi } from '../../../services/apiBase';
import { student_alert } from '../../../services/apiURL';
import studentAlertservice from '../../../services/studentAlertservice';


const MaintenanceAid = () => {

    const { t } = useTranslation(['translation', 'financialAid', 'financialAidHeadcells', 'tableHeadCells']);

    const [selectedSelected, SetSelectedSelected] = useState('')
    const [showTab, setShowTab] = useState(false);
    const [title] = useState('Maintenance');
    const [fyDropDown, setFyDropDown] = useState([]);
    const [fyStatusDropDown, setStatusFyDropDown] = useState([]);
    const [disableFlag, setDisableFlag] = useState(true);
    

    const dispatch = useDispatch()
    const history = useHistory()
    const [isLoading, setIsloading] = useState(true);
    const [popupData, setPopupData] = useState({
        popupHeaderTitle: '',
        alertsData: {},
        open: false,
        studentId: "",
        tableData: []
    });
    const handleClose = () => {
        setPopupData({ ...popupData, open: false })
        setIsloading(false);
        onClose();
    }
    const okAction = () => {
        setPopupData({ ...popupData, open: false })
        setIsloading(false);
    }
    useEffect(() => {
        if (selectedSelected) {
            // setIsloading(true);
            studentAlertservice.getAlerts(selectedSelected).then(alertsData => {
                if (alertsData.open) {
                    setPopupData({
                        popupHeaderTitle: 'Alert',
                        alertsData: alertsData.alertsData,
                        open:alertsData.open,
                        studentId: selectedSelected.studentID,
                        studentName: alertsData?.studentName,
                        okAction: okAction,
                        handleClose: handleClose
                    })
                }       
            }).finally(() => {  
                setIsloading(false);
            });

        }
    }, [selectedSelected])
    useEffect(() => {
        if (history.location.state) {
            const { selectedRow } = history.location.state
            SetSelectedSelected(history.location.state.selectedRow);
            dispatch(getSelectedProfiles({ profileName: selectedRow.studentName, profileId: selectedRow.studentID, type: "student", studentUID: selectedRow.studentUID }))
        }
    }, [])

    const onClose = (value) => {
        SetSelectedSelected(value);
        dispatch(getSelectedProfiles({}));
        history.push("/financial-aid/student-search")
        addData(false);
        document.getElementsByTagName("html")[0].classList.remove("popup-Page");
    };

    const addData = (value) => {
        setShowTab(value)
    }
    const [selectedStatusRow, setSelectedStatusRow] = useState('');

     useEffect(() => {
       
        if (selectedStatusRow !== "" && history.location.state && history.location.state.selectedRow.studentUID == selectedStatusRow.studentUID) {
            setDisableFlag(false);
        }
        else {
            setDisableFlag(true);
            
        }
    }, [selectedStatusRow])
 

    const tabValue = [
        {
            text: t("tabLabels.status", { ns: "financialAid" }),
            component: <Status addDatas={addData} setStatusFyDropDown={setStatusFyDropDown} onClose={onClose} selectedSelected={selectedSelected} selectedStatusRow={selectedStatusRow} setSelectedStatusRow={setSelectedStatusRow} setFyDropDown={setFyDropDown} />
        },
        {
            text: t("tabLabels.isir", { ns: "financialAid" }),
            component: <Isir
                disableFlag={disableFlag}
                addDatas={addData}
                onClose={onClose}
                selectedSelected={selectedSelected}
                fyDropDown={fyDropDown}
                selectedStatusRow={selectedStatusRow}
            />
        },
        {
            text: t("tabLabels.awards", { ns: "financialAid" }),
            component: <Awards addDatas={addData} onClose={onClose} selectedSelected={selectedSelected}
                selectedStatusRow={selectedStatusRow} setSelectedStatusRow={setSelectedStatusRow}
                fyDropDown={fyStatusDropDown}
                disableFlag={disableFlag}
            />
        },
        {
            text: t("tabLabels.documents", { ns: "financialAid" }),
            component: <Documents disableFlag={disableFlag} addDatas={addData} onClose={onClose} selectedSelected={selectedSelected} setSelectedStatusRow={setSelectedStatusRow} selectedStatusRow={selectedStatusRow} fyDropDown={fyDropDown} />
        },
        {
            text: t("tabLabels.more", { ns: "financialAid" }),
            component: <More addDatas={addData} onClose={onClose} selectedSelected={selectedSelected} />
        },
        {
            text: t("tabLabels.isirHistorical", { ns: "financialAid" }),
            component: <IsirHistorical
                disableFlag={disableFlag}
                addDatas={addData}
                onClose={onClose}
                selectedSelected={selectedSelected}
                fyDropDown={fyDropDown}
                selectedStatusRow={selectedStatusRow}
            />
        },
    ]

    return (
        <>
            {(!showTab) && <>
                <Breadcrumb profileData={{ profileName: selectedSelected.studentName, profileId: selectedSelected.studentID }}>
                    {[...financialAid_maintenance].map(({ name, isLink, path }, index) => (
                        <BreadcrumbLink key={index} name={name} path={path} isLink={isLink} />
                    ))}
                </Breadcrumb>
                <HeaderTitle headerTitle={title} help={true} buttonText={t('studentLabel.findStudent')} plus={false} url="/financial-aid/student-search" /></>}
            {popupData.open && <AlertsModal popupData={popupData} onClose={handleClose} />}
            {isLoading ?
                <CustomLoader /> :
                <>
                    <NormalTabs TabLabels={tabValue} variant="fullWidth" showTab={showTab} />
                </>
            }
        </>
    )
}
export default MaintenanceAid;